<template>
  <!-- PAGE CONTAINER -->
  <div class="bg-grey">
    <div class="container page-container">
      <div class="content">
        <div class="row m-0">
          <div class="col-12 col-md-4 p-0" v-for="(item, index) in props.contents" :key="index">
            <!-- CARD IMAGE -->

            <div class="card-image" :style="index + 1 > max? 'display:none':''">
              <div class="image-wrapper">
                <a :href="'/th/plastics' + item.to" v-if="item?.pdf">
                  <!-- <img src="https://plastics.nagase.co.th/wp-content/uploads/2022/07/f-5g.jpg" alt="">-->
                  <img :src="'/th/plastics' + item.img" :alt="item.title || 'Product card image'">
                </a>
                <a :href="'/th/plastics' + item.to" v-else>
                  <img :src="'/th/plastics' + item.img" :alt="item.title || 'Product card image'">
                </a>
              </div>
              <div class="card-content">
                <a :href="'/th/plastics' + item.to" class="card-title">{{ item.title }}</a>
                <!-- <span class="card-description">See our plastic resins from various brands</span> -->
              </div>
            </div>
            <!-- CARD IMAGE -->
          </div>

        </div>
        <p class="text-center py-5 text-primary" @click="show = !show" :style="readmore? '':'display:none'">{{ show ? 'Read Less' :'Read More'  }}</p>
      </div>
    </div>
  </div>
  <!-- PAGE CONTAINER -->
</template>

<script setup>
const readmore = ref(false)
const show = ref(false)
const max = ref(0)
const props = defineProps([
  'contents',
  'max'
])

watch(() => show.value, (val) => {

  val ? max.value = props.contents.length : max.value = props.max
})



onMounted(() => {
  max.value = props.max
  if (props.max) {
    if (props.max < props.contents.length) {
      readmore.value = true
    }
  }
})

</script>

<style scoped>
.card-content {
  display: flex;
  align-items: center;
}

@media screen and (min-width: 768px) {
  .card-content {
    align-items: flex-start;
  }
}

.card-content .card-title {
  font-size: 21px;
}
</style>
